import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { DataTable } from '@/components/DataTable';
import { useToast } from '@/hooks/use-toast';
import { adminQueries } from '@/lib/queries/admin';
import {
  preLoadDefaultProject,
  projectQueries,
  setDefaultProject,
} from '@/lib/queries/project';

import { getIntegrationsColumns } from './-columns';

export const Route = createFileRoute('/_root/admin/')({
  component: RouteComponent,
  loader: preLoadDefaultProject,
});

function RouteComponent() {
  const { queryClient } = Route.useRouteContext();
  const { toast } = useToast();
  const { data } = useSuspenseQuery(adminQueries.integrations());
  const { mutateAsync } = useMutation({
    mutationFn: setDefaultProject,
    onSuccess: () => {
      queryClient.clear();
    },
  });
  const {
    data: { defaultProject },
  } = useSuspenseQuery(projectQueries.default());

  const colums = useMemo(() => {
    return getIntegrationsColumns(mutateAsync, defaultProject?.id, toast);
  }, [mutateAsync, defaultProject?.id, toast]);

  return (
    <>
      <h1 className="mb-4 text-2xl font-bold">
        <FormattedMessage id="admin.title" />
      </h1>
      <DataTable
        data={Object.values(data)}
        columns={colums}
        headersTranslationPath="admin.table"
        initialPagination={{
          pageSize: 1000,
        }}
      />
    </>
  );
}
